import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "waybill-details-modal-invoices" }
const _hoisted_2 = { class: "waybill-details-modal-invoices__title" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"></path><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"></path><path d=\"M10 9H8\"></path><path d=\"M16 13H8\"></path><path d=\"M16 17H8\"></path></svg>", 1)
const _hoisted_4 = { class: "waybill-details-modal-invoices__table" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "№ накладной"),
    /*#__PURE__*/_createElementVNode("th", null, "Адрес"),
    /*#__PURE__*/_createElementVNode("th", null, "Места"),
    /*#__PURE__*/_createElementVNode("th", null, "Физ. вес"),
    /*#__PURE__*/_createElementVNode("th", null, "Объём. вес")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, "—", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)
const _hoisted_8 = { class: "tr--total" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, "Итого", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(" Накладные (" + _toDisplayString(_ctx.invoices.length) + ") ", 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", null, [
        _hoisted_5,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices, (invoice) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: invoice.id
            }, [
              _createElementVNode("td", null, [
                _createVNode(_component_router_link, {
                  class: "table__link",
                  to: `/invoice/${invoice.id}`,
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(invoice.invoiceNumber), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _hoisted_6,
              _createElementVNode("td", null, _toDisplayString(invoice.places), 1),
              _createElementVNode("td", null, _toDisplayString(invoice.weight) + " кг", 1),
              _createElementVNode("td", null, [
                _createTextVNode(_toDisplayString(invoice.volumeWeight) + " м", 1),
                _hoisted_7
              ])
            ]))
          }), 128)),
          _createElementVNode("tr", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("td", null, _toDisplayString(_ctx.getTotalValueByKey('places')), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.getTotalValueByKey('weight')) + " кг", 1),
            _createElementVNode("td", null, [
              _createTextVNode(_toDisplayString(_ctx.getTotalValueByKey('volumeWeight')) + " м", 1),
              _hoisted_11
            ])
          ])
        ])
      ])
    ])
  ]))
}